// extracted by mini-css-extract-plugin
module.exports = {"CogDropdown__toggle":"CogDropdown_CogDropdown__toggle__1U5wu","CogDropdown__item":"CogDropdown_CogDropdown__item__1WIe2"};